import React, { useState } from 'react';
import config from './config';

function ShortenerHome() {
  const [longUrl, setLongUrl] = useState('');
  const [shortUrl, setShortUrl] = useState('');

  const shortenUrl = async () => {
    try {
      const response = await fetch(`${config.serverUrl}/api/shorten`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ longUrl }),
      });
      const data = await response.json();
      setShortUrl(data.shortUrl);
    } catch (error) {
      console.error('Erro:', error);
    }
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>Encurtador de Links</h1>
      <input
        type="text"
        value={longUrl}
        onChange={(e) => setLongUrl(e.target.value)}
        placeholder="Insira URL longa"
        style={{ width: '300px', padding: '10px' }}
      />
      <button onClick={shortenUrl} style={{ padding: '10px 20px', marginLeft: '10px' }}>
        Encurtar
      </button>
      {shortUrl && <p>URL Curta: <a href={shortUrl}>{shortUrl}</a></p>}
    </div>
  );
}

export default ShortenerHome;